// extracted by mini-css-extract-plugin
export default {"mn-feedback-modal":"index_mn-feedback-modal__Wq9EF","mn-form":"index_mn-form__8AMc+","mn-info-modal":"index_mn-info-modal__caDzZ"};